export default "__VITE_ASSET__$05O6rCw__"